import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import MessageBubble from './MessageBubble';
import { MSN } from './msnTheme';

/**
 * Lista de mensagens.
 * FASE 4: a mídia (imagem / áudio / PDF) é renderizada em MessageBubble via fileUrl + type.
 */
export default function MessageList({ messages, currentUserId, contact, isGroup, typingLabel, markRead }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    if (!markRead || !messages?.length) return;
    const unread = messages.filter((m) => m.senderId !== currentUserId && !m.readAt).map((m) => m.id);
    if (unread.length) markRead(unread);
  }, [messages, currentUserId, markRead]);

  return (
    <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column', p: 1.5, bgcolor: MSN.windowBg }}>
      {(messages || []).map((msg) => (
        <MessageBubble
          key={msg.id}
          message={msg}
          isOwn={msg.senderId === currentUserId}
          userName={isGroup ? (msg.senderName || null) : (msg.senderId !== currentUserId ? contact?.nome : null)}
        />
      ))}
      {typingLabel && (
        <Box sx={{ px: 1.5, py: 0.5 }}>
          <Typography variant="caption" sx={{ color: MSN.textSecondary, fontStyle: 'italic', fontSize: 12 }}>
            {typingLabel} está digitando...
          </Typography>
        </Box>
      )}
      <div ref={bottomRef} />
    </Box>
  );
}
